var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgGasThe = function SvgGasThe(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "GT_1_",
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "GT_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GT_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#GT_2_)",
    fill: "#00C752",
    d: "M16.696,27.48c0-2.805,1.515-5.61,3.304-7.481 c1.79,1.871,3.305,4.676,3.305,7.481c0,2.961-1.818,4.519-3.305,4.519C18.486,31.999,16.696,30.441,16.696,27.48"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#GT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M23.748,33.467 c0,2.069-1.68,3.746-3.748,3.746c-2.07,0-3.748-1.677-3.748-3.746"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#GT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 23.748,
    y1: 33.467,
    x2: 29.04,
    y2: 33.467
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#GT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 10.96,
    y1: 33.467,
    x2: 16.252,
    y2: 33.467
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#GT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M25.693,31.048c0,0,3.318-3.084,3.318-8.443C29.012,11.219,20,4.057,20,4.057s-9.013,7.162-9.013,18.547 c0,5.359,3.321,8.443,3.321,8.443"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGasThe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gas-the.a77aa41e.svg";
export { ForwardRef as ReactComponent };